import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=65b4c669&scoped=true&"
import script from "./AppIcon.vue?vue&type=script&lang=js&"
export * from "./AppIcon.vue?vue&type=script&lang=js&"
import style0 from "./AppIcon.vue?vue&type=style&index=0&id=65b4c669&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b4c669",
  null
  
)

export default component.exports